// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@dhl-official/tokens/fonts/Delivery_W_Bd.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@dhl-official/tokens/fonts/Delivery_W_BdIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@dhl-official/tokens/fonts/Delivery_W_CdBlk.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@dhl-official/tokens/fonts/Delivery_W_CdLt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("@dhl-official/tokens/fonts/Delivery_W_It.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("@dhl-official/tokens/fonts/Delivery_W_Lt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("@dhl-official/tokens/fonts/Delivery_W_LtIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("@dhl-official/tokens/fonts/Delivery_W_Rg.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 800;
  font-stretch: condensed;
  font-style: normal;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 200;
  font-stretch: condensed;
  font-style: normal;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2");
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: "Delivery";
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@dhl-official/tokens/dist/css/semantics/font-face.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA6E;EAC7E,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA4E;EAC5E,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA4E;EAC5E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_Bd.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_BdIt.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_CdBlk.woff2\") format(\"woff2\");\n  font-weight: 800;\n  font-stretch: condensed;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_CdLt.woff2\") format(\"woff2\");\n  font-weight: 200;\n  font-stretch: condensed;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_It.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_Lt.woff2\") format(\"woff2\");\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_LtIt.woff2\") format(\"woff2\");\n  font-weight: 100;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Delivery\";\n  font-display: block;\n  src: url(\"@dhl-official/tokens/fonts/Delivery_W_Rg.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
